import type {
  CreateSubAccountRequest,
  SubAccount,
  UpdateAccountProfileRequest,
  UpdateSubAccountRequest,
} from "@adpilot/shared";
import { api } from "@/lib/api";

/** 账号管理 API(ADP-167)— 仅主账号可调用的 /account/* 端点封装。 */

export async function fetchSubAccounts(): Promise<SubAccount[]> {
  const response = await api
    .get("account/sub-accounts")
    .json<{ success: true; data: { subAccounts: SubAccount[] } }>();
  return response.data.subAccounts;
}

export async function createSubAccount(input: CreateSubAccountRequest): Promise<string> {
  const response = await api
    .post("account/sub-accounts", { json: input })
    .json<{ success: true; data: { userId: string } }>();
  return response.data.userId;
}

export async function updateSubAccount(
  userId: string,
  input: UpdateSubAccountRequest,
): Promise<void> {
  await api.patch(`account/sub-accounts/${userId}`, { json: input }).json();
}

export async function deleteSubAccount(userId: string): Promise<void> {
  await api.delete(`account/sub-accounts/${userId}`).json();
}

export async function updateAccountProfile(input: UpdateAccountProfileRequest): Promise<void> {
  await api.patch("account/profile", { json: input }).json();
}

export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  await api.post("auth/password/change", { json: { oldPassword, newPassword } }).json();
}
